import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import BoardsOverview from "./BoardsOverview";

const Home = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const defaultHomeUrl = localStorage.getItem("defaultHomeUrl");
    if (defaultHomeUrl) navigate(defaultHomeUrl);
  }, [navigate]);

  return <BoardsOverview/>;
};

export default Home;
